/**
 * @generated SignedSource<<b69cf9695a059068e44398f9c777152a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ReferringCompanyQuery$variables = {
  displayName?: string | null;
};
export type ReferringCompanyQuery$data = {
  readonly contractingCompany: {
    readonly lightLogoUrl: string | null;
  } | null;
};
export type ReferringCompanyQuery = {
  response: ReferringCompanyQuery$data;
  variables: ReferringCompanyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "displayName"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "displayName",
    "variableName": "displayName"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lightLogoUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReferringCompanyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContractingCompany",
        "kind": "LinkedField",
        "name": "contractingCompany",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReferringCompanyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContractingCompany",
        "kind": "LinkedField",
        "name": "contractingCompany",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e4d2da192d5e938fc1c2a9170fb8c4b7",
    "id": null,
    "metadata": {},
    "name": "ReferringCompanyQuery",
    "operationKind": "query",
    "text": "query ReferringCompanyQuery(\n  $displayName: String\n) {\n  contractingCompany(displayName: $displayName) {\n    lightLogoUrl\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "db9a530c1fa2d8f477149c834bee4ae7";

export default node;
